import { useSendContactTransfer } from 'pages/Transfer/hooks/useSendContactTransfer/useSendContactTransfer'
import { useIsTransferState } from 'pages/Transfer/Transfer.context'
import {
  TransferContactState,
  TransferGeneralState,
} from 'pages/Transfer/Transfer.stateMachine'
import { StyledNextButton } from 'components/Buttons/ActionButtonsGroup/ActionButtonsGroup.styled'
import { shared } from 'translations'

export const TransferContactSubmitButton = () => {
  const transferMoney = useSendContactTransfer()
  const isContactTransferState = useIsTransferState<TransferContactState>(
    TransferGeneralState.ContactTransfer
  )
  const isTransferringInProgress = isContactTransferState([
    TransferContactState.Sending,
    TransferContactState.DeOutFallbackSending,
  ])

  return (
    <StyledNextButton
      isLoading={isTransferringInProgress}
      onClick={transferMoney}
    >
      {shared.pay}
    </StyledNextButton>
  )
}
